<div fxLayout="row" fxLayoutAlign="space-between center">
  <h2 mat-dialog-title></h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon aria-label="close">close</mat-icon>
  </button>
</div>
<div mat-dialog-content>
  <div id="lineChart">
    <canvas id="canvas-line">{{ myChart }}</canvas>
  </div>
</div>
